export default {
  Home: "Home",
  Conversation: "Conversation management",
  Config: "Configuration management",
  Service: "Customer service management",
  Label: "Tag management",
  System: "System administration",
  Users: "User management",
  Menus: "Menu management",
  SystemDept: "Department management",
  Roles: "Role management",
  Report: "PRESENTATION",
  PersonalCenter: "Personal Center",
  QuickReply: "Quick replies",
  statement: "Recall statistics",
  Task: "Task management",
  TaskList: "Task list",
  TaskConfig: "Task configuration",
};
